import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import styles from "./PredictionPopup.module.css";
import closebutton from "../../assests/closebutton.svg";
import ContactUsFooter from "../ContactUsFooter/ContactUsFooter";
import Context from "../../context/Context";
import { useNavigate } from "react-router";
import axios from "axios";
import LoadingFromCenter from "../LoadingFromCenter/LoadingFromCenter";
import Loading from "../Loading/Loading";
import ProfilePopup from "../Profile/ProfilePopup";
import multipleFile from "../../assests/multipleFile.svg";

export default function PredictionPopup({ setPopup, data }) {
  const [show, setShow] = useState(false);
  const [predictions, setPredictions] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [dataloading, setDataLoading] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [singleData, setSingleData] = useState({});
  useEffect(() => {
    setShow(true);
  }, []);
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  const { details } = useContext(Context);
  const navigate = useNavigate();

  useEffect(() => {
    setDataLoading(true);
    let cancel;
    const { organiserId, campaignId, contestId, team, matchDetails } = data;
    let url = `${process.env.REACT_APP_GET_PREDICTION}/${organiserId}/${campaignId}/${contestId}/${matchDetails?.id}/${team}?page=${pageNumber}&limit=6`;
    axios({
      method: "get",
      url: url,
      cancelToken: new axios.CancelToken((c) => (cancel = c)),
    })
      .then((res) => {
        setPredictions((prevContestData) => {
          const newData = Array.isArray(res?.data?.data) ? res.data.data : [];
          return [...new Set([...prevContestData, ...newData])];
        });
        setHasMore(res?.data?.data?.length > 0);
        setDataLoading(false);
      })
      .catch((e) => {
        if (axios.isCancel(e)) return;
        setDataLoading(false);
      });

    return () => cancel();
  }, [pageNumber]);
  const observer = useRef();
  const lastElementRef = useCallback(
    (node) => {
      if (dataloading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [dataloading, hasMore]
  );

  const profileHelpNavigate = () => {
    navigate(`/profile/help`);
  };
  const handleFileClick = (obj) => {
    setShowPreview(true);
    setSingleData(obj);
  };
  return (
    <>
      {showPreview && (
        <ProfilePopup
          setShowPreview={setShowPreview}
          singleFileDetails={singleData}
          type="winner"
        />
      )}
      <div className={styles.popupWrapper}>
        <div
          className={`h-full w-full bg-black bg-opacity-40 max-w-[425px] mx-auto pt-[50px] backdrop-blur-sm transform transition-transform ease-in-out duration-300
      ${show ? "translate-y-0" : "translate-y-full"}
      `}
        >
          {" "}
          <div className={`no-scrollbar ${styles.parentDiv}`}>
            <div className="flex justify-between items-center w-[100%] sticky top-0 left-0 bg-black z-10">
              <p className="text-large-bold p-[20px]">Predictions</p>
              <img
                src={closebutton}
                onClick={() => setPopup(false)}
                className=" hover:cursor-pointer p-[20px]"
              />
            </div>
            <div className="px-[20px]">
              <div className="flex flex-col items-center cursor-pointer p-[10px] rounded-[10px] relative w-full ">
                <div className="w-[62px] h-[62px] rounded-[8px] overflow-hidden bg-white">
                  <img src={data?.matchDetails[data?.team]?.logo} alt="" />
                </div>
                <p className="text-white mt-[12px] text-center text-small-medium">
                  {data?.matchDetails[data?.team]?.name}
                </p>
              </div>
              <div className="seperator mb-[20px]" />
              <div className={styles.grid}>
                <div className={styles.pureGrid}>
                  {predictions?.map((obj, index) => {
                    return (
                      <div
                        ref={
                          index === predictions?.length - 1
                            ? lastElementRef
                            : null
                        }
                        onClick={() => handleFileClick(obj)}
                      >
                        <div className="relative rounded-[6px]">
                          <img
                            className={styles.gridingg}
                            src={
                              obj.thumbnailUrl
                                ? obj.thumbnailUrl
                                : obj?.fileUrls[0]?.fileUrl
                            }
                            alt=""
                          />
                          <div className="absolute top-0 left-0 w-[100%] h-[100%] flex flex-col justify-between py-[4px] px-[8px] text-smallest top-and-bottom-gradient">
                            <div className=" flex items-center justify-between">
                              <div>
                                {obj?.fileUrls?.length > 1 && (
                                  <img src={multipleFile} alt="" />
                                )}
                              </div>
                              <div className="flex gap-[5px]">
                                <p className="text-small">{obj?.likesCount}</p>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="18"
                                  viewBox="0 0 24 21"
                                  fill="none"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M12 3.34243C9.80074 0.847315 6.12572 0.0762153 3.37017 2.36099C0.614608 4.64577 0.226662 8.46578 2.39062 11.168C4.18981 13.4147 9.63476 18.1532 11.4193 19.6869C11.6189 19.8585 11.7188 19.9443 11.8353 19.978C11.9368 20.0073 12.048 20.0073 12.1497 19.978C12.2662 19.9443 12.3659 19.8585 12.5657 19.6869C14.3502 18.1532 19.7951 13.4147 21.5943 11.168C23.7583 8.46578 23.4177 4.62174 20.6147 2.36099C17.8118 0.10025 14.1993 0.847315 12 3.34243Z"
                                    fill={obj?.liked ? "#F11057" : "#FFFEFE"}
                                    stroke=""
                                    stroke-width="1.67"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                              </div>
                            </div>
                            <div className=" flex items-center justify-between">
                              <p className="truncate max-w-[80%]">
                                {obj?.participantName}
                              </p>
                            </div>
                          </div>
                          {/* {obj?.fileType === "video" && (
                          <img className={styles.playbtn} src={Play} alt="" />
                        )}
                        {obj?.status == "EDITED" && (
                          <div className={styles.filter}>
                            <p className="text-smallest">Under Review</p>
                          </div>
                        )} */}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              {dataloading && <Loading />}
              <div className="seperator mt-[30px]" />
            </div>

            <ContactUsFooter profileHelpNavigate={profileHelpNavigate} />
          </div>
        </div>
      </div>
    </>
  );
}
